export default __webpack_public_path__ + "static/media/org-event-registrations.107a8e75.png";